import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Home from './pages/Home'
import MyEvents from './pages/MyEvents'
import Register from './pages/Register'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Entry from './pages/Entry'
import Leaderboard from './pages/Leaderboard'
import Admin from './pages/Admin'
import ForgotPassword from './pages/ForgotPassword'
import MyPredictions from './pages/MyPredictions'
import Phase2Entry from './pages/Phase2Entry'
import ResetPassword from './pages/ResetPassword'
import ChangePassword from './pages/ChangePassword'
import LMSEventPage from './pages/LMSEventPage'
import LeagueDetail from './pages/LeagueDetail'
import HowToPlay from './pages/HowToPlay'
import './styles/global.css'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MyEvents />} />
        <Route path="/welcome" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        {/* Legacy landing, retired per MY_EVENTS_HUB.md: My Events (/) is the
            one front door now. The World Cup's own entries/points page moved
            to /world-cup so it stays reachable, just not as the default. */}
        <Route path="/dashboard" element={<Navigate to="/" replace />} />
        <Route path="/world-cup" element={<Dashboard />} />
        <Route path="/entry/:entryId" element={<Entry />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/predictions/:entryId" element={<MyPredictions />} />
        <Route path="/phase2/:entryId" element={<Phase2Entry />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/lms/:eventId" element={<LMSEventPage />} />
        <Route path="/lms/:eventId/leagues/:leagueId" element={<LeagueDetail />} />
        <Route path="/how-to-play" element={<HowToPlay />} />
        {/* Retired: My Game's content is now the round detail under each
            event (/lms/:eventId), reachable from My Events. */}
        <Route path="/my-game" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}

export default App
